export const INPUT_NUMBER = 'INPUT_NUMBER'
export const NEW_UUID_ORDER_ID = 'NEW_UUID_ORDER_ID'
export const GET_RATES = 'GET_RATES'
export const CONVERT_CURRENCY = 'CONVERT_CURRENCY'
export const SELECTOR_CHANGED = 'SELECTOR_CHANGED'
export const RUN_KYC = 'RUN_KYC'
export const STORE_PARAMS = 'STORE_PARAMS'
export const NEW_ERROR = 'NEW_ERROR'
export const RESET_ERROR = 'RESET_ERROR'
export const DISABLE_NEXT_BUTTON = 'DISABLE_NEXT_BUTTON'
export const GET_IP = 'GET_IP'
export const GET_URL = 'GET_URL'
export const GET_MOONPAY_URL = 'GET_MOONPAY_URL'